import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import {
  TableCellDirective,
  TableColumnDirective,
  TableComponent,
  TableHeaderDirective,
  TableRowActionsDirective,
} from '@libs/common/components';
import { LastOrderedProductModel } from '@libs/shop/models';
import { PartialProductImpressionDirective } from '@libs/shared/tracking';
import { ProductPriceVisibilityService } from '@libs/shared/ui';
import { ProductLabelsComponent, ProductPricesComponent } from '../catalog';
import { ProductPriceFormatterComponent } from '../catalog/product-prices/product-price-formatter';
import { AddToCartComponent, OrderQuantitiesComponent } from '../elements';

@Component({
  selector: 'ui-last-ordered-products-table',
  templateUrl: './last-ordered-products-table.component.html',
  styleUrls: ['./last-ordered-products-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TableComponent,
    ProductPricesComponent,
    TableHeaderDirective,
    TableColumnDirective,
    TableCellDirective,
    TableRowActionsDirective,
    ProductLabelsComponent,
    OrderQuantitiesComponent,
    AddToCartComponent,
    ProductPriceFormatterComponent,
    PartialProductImpressionDirective,
  ],
})
export class LastOrderedProductsTableComponent {
  public readonly productPriceVisibilityService: ProductPriceVisibilityService = inject(ProductPriceVisibilityService);
  public products: InputSignal<LastOrderedProductModel[]> = input.required();
  public showPriceColumn: Signal<boolean> = computed(() => this.products().some(x => this.productPriceVisibilityService.arePricesVisible(x.prices)));
  public hasStableArticleNumber: Signal<boolean> = computed(() => this.products().some(x => x.identifiers.articleNumberStable));
  public category: InputSignal<string> = input.required();
}
